// Accounting Commission Payable Vuex

import state from './commissionStates.js'
import * as getters from './commissionGetters.js'
import * as mutations from './commissionMutations.js'
import * as actions from './commissionActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
